module.exports = __webpack_public_path__ + "img/MARAVILLOSA.e0c8fe87.png";